
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import differenceInDays from 'date-fns/differenceInDays';
import format from 'date-fns/format';
import moment from 'moment/min/moment-with-locales';
import 'moment/min/locales';
import { enUS } from 'date-fns/esm/locale'

import { LabeledValue } from 'antd/lib/select';
import { FormattedMessage } from 'react-intl';

import { MONTHS, SESSION_EXPIRATION_DELAY, DATE_FORMAT_ISO, DATE_FORMAT_UNIT_ROW, DATE_FORMAT_BASE, DATE_FORMAT_UNIT_ROW_WITHOUT_COMA } from '@share/constants';

import { creatingArrayWithNumber } from './common';
import { get, isEmpty } from 'lodash';

const MAX_YEARS = 20;
const isoFormat = 'yyyy-MM-dd';
const startTime = 'T00:00:01.000Z';

export const getMonths = (): LabeledValue[] => {
  return [
    { value: 0, label: <FormattedMessage id="january" /> },
    { value: 1, label: <FormattedMessage id="february" /> },
    { value: 2, label: <FormattedMessage id="march" /> },
    { value: 3, label: <FormattedMessage id="april" /> },
    { value: 4, label: <FormattedMessage id="may" /> },
    { value: 5, label: <FormattedMessage id="june" /> },
    { value: 6, label: <FormattedMessage id="july" /> },
    { value: 7, label: <FormattedMessage id="august" /> },
    { value: 8, label: <FormattedMessage id="september" /> },
    { value: 9, label: <FormattedMessage id="october" /> },
    { value: 10, label: <FormattedMessage id="november" /> },
    { value: 11, label: <FormattedMessage id="december" /> },
  ];
};

export const GetDatediff = (startDate: string, endDate: string) => {
  return moment(endDate, 'yyyy-MM-DD').diff(moment(startDate, 'yyyy-MM-DD'), 'days');
}

export const getTimeout = (expireDate: string): number => {
  const date = moment(expireDate, 'YYYY-MM-DDThh:mm:ssZ').toDate();
  const now = moment().toDate();
  return differenceInMilliseconds(date, now) - SESSION_EXPIRATION_DELAY;
};

export const getNights = (dateFrom: string, dateTo: string): number => {
  const toDate = moment(dateTo, 'YYYY-MM-DDThh:mm:ssZ').toDate();
  const fromDate = moment(dateFrom, 'YYYY-MM-DDThh:mm:ssZ').toDate();
  return differenceInDays(toDate, fromDate);
};

export const getOptionsYear = (): number[] => {
  const date = new Date();
  const currentYear = date.getFullYear();

  return creatingArrayWithNumber(MAX_YEARS, currentYear);
};

export const getOptionsMonths = (year: string): any[] => {
  const date = moment();
  const currentMonth = date.month();
  const currentYear = date.year();

  if (currentYear === parseInt(year)) {
    return MONTHS.filter(month => parseInt(month.number) - 1 >= currentMonth)
  }

  return MONTHS;
};

export const isValidMonth = (month: string, year: string): boolean => {
  const date = moment();
  const currentMonth = date.month();
  const currentYear = date.year();

  if (currentYear === parseInt(year)) {
    return parseInt(month) >= currentMonth;
  }

  return true;
};

export const formatDateCheckInOut = (date: string | undefined | null, dateFormat: string, localeSelected?: Locale): string => {
  if (!date) {
    return '';
  }
  
  const parsedDate = getDateCheckInOut(date);
  if (!parsedDate) {
    return '';
  }

  const locale = localeSelected ? localeSelected : enUS;
  return format(parsedDate, dateFormat, { locale });
};

export const formatDateCheckInOutWithLabel = (date: string): string => {
  const momentDate = moment(date, DATE_FORMAT_BASE);
  const formattedDate = momentDate.format(isSpanish() ? DATE_FORMAT_UNIT_ROW_WITHOUT_COMA : DATE_FORMAT_UNIT_ROW);
  const formattedDateSplitted = formattedDate.split(', ');
  return `<label className="grey">${get(formattedDateSplitted, '[0]')}</label>, ${get(formattedDateSplitted, '[1]')}${!isSpanish() ? ',' : ''} ${!isSpanish() ? get(formattedDateSplitted, '[2]') : ''}`
};

export const getDateCheckInOut = (date?: string | undefined, format?: string): Date | undefined => {
  if (!(date?.length ?? 0 >= 10)) {
    return undefined;
  }

  return moment(date, format ? format : DATE_FORMAT_ISO).toDate();
};

export const getDateCheckInOutISOString = (date: Date | undefined | null): string => {
  if (!date) {
    return '';
  }
  return format(date, isoFormat) + startTime;
};

export const IsMinDate = (date: Date | undefined | null): boolean => {
  if (!date) {
    return false;
  }
  
  const minDate = moment("0001-01-01T00:00:00");
  const receiveDate = moment(date);
  return !(moment(receiveDate).isAfter(minDate));
};

export const isSpanish = () => {
  const selectedLanguage = localStorage.getItem("SELECTED_LANGUAGE_LABEL") ?? undefined;
  const selectedCountry = localStorage.getItem("SELECTED_LANGUAGE_COUNRTY_LABEL") ?? undefined;
  return selectedLanguage === 'es' && selectedCountry === 'es';
}

export const to12Hour = (time24: string | undefined | null): string | undefined | null => {
  try {
    if (typeof time24 === 'string' && time24 && !isEmpty(time24)) {
      if (!time24.toLocaleLowerCase().includes('am') && !time24.toLocaleLowerCase().includes('pm') && !isEmpty(time24)) {
        const parts = time24.split(':');
        if (parts.length !== 2) {
          throw new Error(`Invalid format date: ${time24}`);
        }
        const [hourStr, minStr] = parts;
        const h = parseInt(hourStr, 10);
        if (isNaN(h) || isNaN(parseInt(minStr, 10)) || minStr.length !== 2) {
          throw new Error(`Invalid format date: ${time24}`);
        }

        const suffix = h < 12 ? 'AM' : 'PM';

        const hour12 = ((h + 11) % 12) + 1;

        return `${hour12}:${minStr} ${suffix}`;
      } else {
        return time24;
      }
    } else {
      return time24;
    }
  } catch (error) {
    return time24;
  }
}